/* eslint-disable import/prefer-default-export,import/extensions */
export { default as redirectExternal } from './redirectExternal';
